import styles from "./styles.module.scss";
import reusedStyles from "../styles.module.scss";
import { ReactNode, useRef } from "react";
import { motion, MotionValue, useScroll, useSpring, useTransform } from "framer-motion";

type Step = {
	title: string
	content: ReactNode
	img: string
};

const steps: Step[] = [
	{
		title: "Step 1",
		content: <>Download Honda RoadSync from the Google Play Store (for Android) or App Store (for iOS) and allow permissions when required.</>,
		img: "/roadsync/step-1.jpg"
	},
	{
		title: "Step 2",
		content: <>Pair your device to your Honda, following the on-screen instructions.</>,
		img: "/roadsync/step-3.jpg"
	},
	{
		title: "Step 3",
		content: <>Once paired and enabled, choose a Google account (for Android) or Apple account (for iOS).</>,
		img: "/roadsync/step-3.jpg"
	},
	{
		title: "Step 4",
		content: <>That’s it. You’re connected and ready to explore all of the features now at your fingertips – and all by Bluetooth® (no cables required).</>,
		img: "/roadsync/step-4.jpg"
	},
];

function useClampedPosition(value: MotionValue<number>) {
	return useTransform(value, [0.5, 1], ["-25%", "0%"]);
}

const Block = ({ step }: { step: Step }) => {
	const ref = useRef(null);

	const { scrollYProgress }: { scrollYProgress: MotionValue<number> } = useScroll({
		target: ref,
		offset: ["start end", "end end"],
	});

	// const positionSmooth = useSpring(scrollYProgress, {
	// 	stiffness: 50,
	// 	damping: 20,
	// 	restDelta: 0.001
	// });

	const position = useClampedPosition(scrollYProgress);

	return (
		<motion.div
			ref={ref}
			className="block"
			style={{
				x: position
			}}
			transition={{ ease: [0.04, 0.62, 0.23, 0.98] }}
		>
			<div className="img"><img src={step.img} alt={step.title} /></div>
			<h3>{step.title}</h3>
			<div className="content">
				{step.content}
			</div>
		</motion.div>
	);
}

export default function Connect() {
	return (
		<div className={styles.section}>
			<h2 className={reusedStyles.heading}>
				How to connect Honda Roadsync
			</h2>
			<div className={styles.diagram}>
				<div className="container">
					{steps.map((step, s) => {
						return (
							<Block key={s} step={step} />
						);
					})}
				</div>
			</div>
		</div>
	);
}